export const SET_REFRESH_HASH = 'SET_REFRESH_HASH';
export const CLEAR_HASH = 'CLEAR_HASH';

export const SET_PASSWORD_REQUEST = 'SET_PASSWORD_REQUEST';
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';



// WEBPACK FOOTER //
// ./src/Store/ActionTypes/MetaActionTypes.js